/**
 * The api connect logo, shown when the request is not on a branded (white-label)
 * subdomain. Mirrors the fallback the blade layer applies when building `logoUrl`,
 * so a component resolving its own logo agrees with the prop the layouts pass down.
 */
export const DEFAULT_LOGO_URL = `${import.meta.env.VITE_CDN_ENDPOINT}/images/api-connect-logo.png`;
